/**
 * English language pack
 */
export default {
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    reset: 'Reset',
    submit: 'Submit',
    back: 'Back',
    close: 'Close',
    refresh: 'Refresh',
    loading: 'Loading...',
    success: 'Operation successful',
    error: 'Operation failed',
    warning: 'Warning',
    info: 'Info',
    yes: 'Yes',
    no: 'No',
    enable: 'Enable',
    disable: 'Disable',
    enabled: 'Enabled',
    disabled: 'Disabled',
    online: 'Online',
    offline: 'Offline',
    normal: 'Normal',
    total: 'Total',
    items: 'items',
    all: 'All',
    export: 'Export Data',
    import: 'Import Data',
    download: 'Download',
    upload: 'Upload',
    view: 'View',
    copy: 'Copy',
    clear: 'Clear',
    filter: 'Filter',
    sort: 'Sort',
    pleaseSelect: 'Please select',
    confirmSave: 'Confirm save?',
    setAsDefault: 'Set as Default',
    user: 'User',
    personalCenter: 'Account',
    personalSettings: 'Settings',
    logout: 'Logout',
    // Common fields
    avatar: 'Avatar',
    name: 'Name',
    description: 'Description',
    status: 'Status',
    createTime: 'Create Time',
    updateTime: 'Update Time',
    isDefault: 'Default',
    default: 'Default',
    platform: 'Platform',
    // Common operations
    clickToUpload: 'Click to upload',
    changeAvatar: 'Change Avatar',
    uploadAvatar: 'Upload Avatar',
    removeAvatar: 'Remove Avatar',
    avatarTip: 'Support JPG, PNG, GIF format, max 2MB',
    avatarUploadFailed: 'Avatar upload failed: ',
    avatarUploadSuccess: 'Avatar uploaded successfully',
    clickToChangeAvatar: 'Click to change avatar',
    avatarFormatTip: 'Supports JPG, PNG format, size not exceeding 2MB',
    // File upload validation
    onlyImageFiles: 'Only image files allowed!',
    imageSizeLimit: 'Image size cannot exceed 2MB!',
    // Common prompts
    confirmSetDefault: 'Are you sure to set this {type} as default?',
    setDefaultTip: 'After setting as default, the system will prioritize this {type}, and the original default {type} will be unset.',
    setDefaultSuccess: 'Set "{name}" as default {type}',
    setDefaultFailed: 'Failed to set default {type}',
    operationFailed: 'Operation failed',
    operationSuccess: 'Operation successful',
    deleteSuccess: 'Deleted successfully',
    deleteFailed: 'Delete failed',
    confirmDelete: 'Are you sure to delete?',
    system: 'System',
    noData: 'No data',
    loadFailed: 'Failed to load',
    addSuccess: 'Added successfully',
    updateSuccess: 'Updated successfully',
    enterUsername: 'Please enter username',
    enterEmail: 'Please enter email',
    enterPhone: 'Please enter phone number',
    enterPassword: 'Please enter password',
    enterConfirmPassword: 'Please enter password again',
    enterVerificationCode: 'Please enter verification code',
    // Platform config common
    platformConfig: 'Platform Configuration',
    getPlatformConfigFailed: 'Failed to get platform configuration',
    updatePlatformConfigSuccess: 'Platform configuration updated successfully',
    addPlatformConfigSuccess: 'Platform configuration added successfully',
    updatePlatformConfigFailed: 'Failed to update platform configuration',
    addPlatformConfigFailed: 'Failed to add platform configuration',
  },

  menu: {
    dashboard: 'Dashboard',
    user: 'User Management',
    device: 'Device Management',
    message: 'Message Management',
    role: 'Role Configuration',
    template: 'Template Management',
    config: 'Configuration',
    agent: 'Agent Management',
    sttConfig: 'STT Config',
    ttsConfig: 'TTS Config',
    setting: 'Settings',
    account: 'Account',
    personalConfig: 'Settings',

    // Menu Management
    menu: 'Menu Management',
    menuList: 'Menu List',
    addMenu: 'Add Menu',
    editMenu: 'Edit Menu',
    addChild: 'Add Child Menu',
    parentMenu: 'Parent Menu',
    rootMenu: 'Root Menu',
    selectParent: 'Please select parent menu',
    name: 'Menu Name',
    nameRequired: 'Please enter menu name',
    namePlaceholder: 'Enter menu name',
    code: 'Menu Code',
    codeRequired: 'Please enter menu code',
    codePlaceholder: 'Enter menu code',
    type: 'Menu Type',
    typeRequired: 'Please select menu type',
    typePlaceholder: 'Select menu type',
    typeMenu: 'Menu',
    typeButton: 'Button',
    typeLink: 'Link',
    routePath: 'Route Path',
    routePathPlaceholder: 'Enter route path',
    componentPath: 'Component Path',
    componentPathPlaceholder: 'Enter component path',
    icon: 'Menu Icon',
    iconPlaceholder: 'Select menu icon',
    permissionCode: 'Permission Code',
    permissionCodePlaceholder: 'Enter permission code',
    visible: 'Visible',
    isCached: 'Cached',
    confirmDelete: 'Are you sure to delete menu [{name}]? Child menus will also be deleted!',
    permission: 'Permission Management',
  },

  auth: {
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    forgetPassword: 'Forgot Password',
    verificationCode: 'Verification Code',
    rememberMe: 'Remember Me',
    loginSuccess: 'Login successful',
    loginFailed: 'Login failed',
    logoutSuccess: 'Logout successful',
    registerSuccess: 'Registration successful',
    passwordReset: 'Password reset successful',
    loginAgreement: 'By logging in, you agree to',
    otherLoginMethods: 'Other login methods',
    noAccount: 'No account?',
    // Register related
    name: 'Name',
    enterName: 'Please enter name',
    enterPhoneOptional: 'Please enter phone number (optional)',
    emailVerificationCode: 'Email Verification Code',
    agreeTerms: 'I have read and agree to',
    agreeTermsRequired: 'Please agree to user agreement',
    haveAccount: 'Already have an account?',
    loginNow: 'Login now',
    // Forgot password related
    newPassword: 'New Password',
    enterNewPassword: 'Please enter new password',
    confirmNewPassword: 'Confirm New Password',
    enterConfirmNewPassword: 'Please enter new password again',
    verifyEmail: 'Verify Email',
    resetPassword: 'Reset Password',
    rememberPassword: 'Recall your password?',
    backToLogin: 'Back to Login',
    // Verification code related
    sending: 'Sending...',
    resendAfter: 'Resend in {seconds}s',
    sendVerificationCode: 'Send Verification Code',
    enterEmailFirst: 'Please enter email address first!',
    enterValidEmail: 'Please enter a valid email format!',
    verificationCodeSent: 'Verification code has been sent to your email!',
    sendVerificationCodeFailed: 'Failed to send verification code!',
    sendVerificationCodeRetry: 'Failed to send verification code, please try again later',
    verificationSuccess: 'Verification successful!',
    verificationCodeError: 'Verification code error',
  },

  user: {
    username: 'Username',
    email: 'Email',
    phone: 'Phone',
    role: 'Role',
    admin: 'Admin',
    normalUser: 'Normal User',
    lastLoginTime: 'Last Login Time',
    lastLoginIp: 'Last Login IP',
    deviceCount: 'Device Count',
    onlineDeviceCount: 'Online Devices',
    messageCount: 'Message Count',
    accountType: 'Account Type',
    normal: 'Normal',
    disabled: 'Disabled',
    assignRoles: 'Assign Roles',
    assignRolesFor: 'Assign roles for user {name}',
    confirmToggleStatus: 'Are you sure to {action} user [{name}]?',
    cancelAccount: 'Cancel account',
    cancelSuccess: 'Account cancelled',
    cancelFailed: 'Failed to cancel account',
    confirmDeleteUser: 'Cancel account [{name}]? Sign-in will be disabled and the phone, email, and WeChat identity can register again. Historical assets and audit records will be retained.',
  },

  // Permission Management
  permission: {
    name: 'Permission Name',
    code: 'Permission Code',
    resourceType: 'Resource Type',
    resourceUrl: 'Resource URL',
    httpMethod: 'HTTP Method',
    confirmDelete: 'Are you sure to delete permission [{name}]?',
  },

  // Role Management
  role: {
    name: 'Role Name',
    code: 'Role Code',
    description: 'Description',
    isSystem: 'System Role',
    configPermissions: 'Configure Permissions',
    configMenus: 'Configure Menus',
    confirmDelete: 'Are you sure to delete role [{name}]?',
    cannotDeleteSystem: 'System built-in role cannot be deleted',
    permissionConfigTitle: 'Permission Config - {name}',
    menuConfigTitle: 'Menu Config - {name}',
    expandAll: 'Expand All',
    collapseAll: 'Collapse All',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    selectedCount: '{count} selected',
    searchPermission: 'Search permission name',
    searchMenu: 'Search menu name',
    noData: 'No data',
  },

  device: {
    deviceId: 'Device ID',
    deviceName: 'Device Name',
    deviceType: 'Device Type',
    onlineStatus: 'Online',
    offlineStatus: 'Offline',
    lastOnlineTime: 'Last Online Time',
    owner: 'Owner',
    wifiName: 'WIFI Name',
    location: 'Location',
    productType: 'Product Type',
    addDevice: 'Add Device',
    enterDeviceCode: 'Enter device code',
    confirmDelete: 'Are you sure to delete this device?',
    configureDefaultRole: 'Please configure default role first',
    version: 'Version',
    activeTime: 'Active Time',
    // Role related
    roleName: 'Role Name',
    roleDesc: 'Role Description',
    voiceName: 'Voice',
    modelName: 'Conversation Model',
    sttName: 'Speech Recognition',
    totalDevice: 'Device Count',
    createRole: 'Create Role',
    updateRole: 'Update Role',
    roleList: 'Role List',
    enterRoleName: 'Enter role name',
    setAsDefaultRole: 'Set as Default Role',
    defaultRoleTip: 'When set as default, this role will be used preferentially',
    conversationModelSettings: 'Conversation Model Settings',
    modelType: 'Model Type',
    llmModel: 'LLM Model',
    agent: 'Agent',
    model: 'Model',
    selectModel: 'Please select model',
    conversationModelAdvanced: 'Conversation Model Advanced Settings',
    temperature: 'Temperature',
    temperatureTip: 'Control answer creativity:\n- Low value (0.2): More precise and conservative\n- High value (0.8): More creative and diverse',
    topP: 'Top P',
    topPTip: 'Control vocabulary selection range:\n- Low value (0.5): More focused\n- High value (0.9): Consider more possibilities',
    speechRecognitionSettings: 'Speech Recognition Settings',
    speechRecognition: 'Speech Recognition',
    selectSpeechRecognition: 'Please select speech recognition configuration',
    speechRecognitionAdvanced: 'Speech Recognition Advanced Settings (VAD Parameters)',
    speechThreshold: 'Speech Threshold',
    silenceThreshold: 'Silence Threshold',
    energyThreshold: 'Energy Threshold',
    silenceDuration: 'Silence Duration',
    voiceSynthesisSettings: 'Voice Synthesis Settings',
    selectVoice: 'Please select voice',
    rolePrompt: 'Role Prompt',
    agentPrompt: 'Agent mode uses built-in prompts, no additional setup required',
    agentPromptDesc: 'Agent includes preset prompts and knowledge base, will automatically use agent description as role prompt',
    useTemplate: 'Use Template',
    custom: 'Custom',
    selectTemplate: 'Select Template',
    templateManagement: 'Template Management',
    enterRolePrompt: 'Enter role prompt, describe character traits, knowledge background and behavior patterns',
    cancel: 'Cancel',
    confirmDeleteRole: 'Are you sure to delete this role?',
    deleteRole: 'Delete Role',
    settingDefaultRole: 'Setting default role...',
    setAsDefaultSuccess: 'Set as default role',
    setAsDefaultFailed: 'Setting failed',
    deleteRoleSuccess: 'Delete successful',
    deleteRoleFailed: 'Delete failed',
    createRoleSuccess: 'Create successful',
    updateRoleSuccess: 'Update successful',
    checkForm: 'Please check if the form is filled correctly',
    voiceNotFound: 'Voice information not found',
    audioUrlInvalid: 'Audio URL invalid',
    audioPlayFailed: 'Audio playback failed',
    getTestAudioFailed: 'Failed to get test audio',
    playVoiceFailed: 'Voice playback failed',
    loadTemplateFailed: 'Failed to load template list',
    voskLocalRecognition: 'Vosk Local Recognition',
    unknown: 'Unknown',
    unknownModel: 'Unknown Model',
    voiceTestMessage: 'Hello, I am your voice assistant, I am very happy to serve you',
  },

  template: {
    templateName: 'Template Name',
    templateList: 'Prompt Template List',
    createTemplate: 'Create Template',
    editTemplate: 'Edit Prompt Template',
    templatePreview: 'Template Preview',
    category: 'Category',
    templateCategory: 'Template Category',
    customCategory: 'Custom Category',
    templateDesc: 'Template Description',
    templateContent: 'Template Content',
    isDefault: 'Is Default',
    default: 'Default',
    defaultTemplate: 'Default Template',
    createTime: 'Create Time',
    confirmDelete: 'Are you sure to delete this template?',
    enterTemplateName: 'Please enter template name',
    selectCategory: 'Please select template category',
    enterCustomCategory: 'Please enter custom category name',
    enterTemplateDesc: 'Please enter template description',
    enterTemplateContent: 'Please enter template content',
    templateContentPlaceholder: 'Please enter template content, describing the character\'s characteristics, knowledge background and behavior',
    defaultTip: 'When set as default, this template will be displayed first',
    categoryBasic: 'Basic Role',
    categoryProfessional: 'Professional Role',
    categorySocial: 'Social Role',
    categoryEntertainment: 'Entertainment Role',
    createSuccess: 'Template created successfully',
    updateSuccess: 'Template updated successfully',
    deleteSuccess: 'Template deleted',
    deleteFailed: 'Delete failed',
    setDefaultSuccess: 'Set as default template',
    operationFailed: 'Operation failed',
  },

  config: {
    llm: 'Model',
    stt: 'Speech Recognition',
    tts: 'Text to Speech',
    category: 'Category',
    modelType: 'Model Type',
    list: 'List',
    create: 'Create',
    confirmDelete: 'Are you sure to delete this {type} configuration?',
    pleaseEnter: 'Please enter',
    selectCategory: 'Please select {type} category',
    selectModelType: 'Please select model type',
    enterName: 'Please enter {type} name',
    enterDescription: 'Please enter {type} description',
    enterField: 'Please enter {field}',
    selectCategoryFirst: 'Please select {type} category first',
    update: 'Update {type}',
    parameterConfig: 'Parameter Configuration',
    defaultTip: 'When set as default, this configuration will be used first',
    chatModel: 'Chat Model',
    visionModel: 'Vision Model',
    intentModel: 'Intent Model',
    embeddingModel: 'Embedding Model',
    defaultChat: 'Default Chat',
    defaultVision: 'Default Vision',
    defaultIntent: 'Default Intent',
    defaultEmbedding: 'Default Embedding',
    defaultStt: 'Default Speech Recognition',
    createSuccess: 'Created successfully',
    updateSuccess: 'Updated successfully',
    fillRequiredFields: 'Please fill in required fields',
    modelNameNoChinese: 'Model name cannot contain Chinese characters, please enter a valid model name',
    modelNameInvalid: 'Model name "{name}" is not in the valid list',
  },

  message: {
    content: 'Content',
    type: 'Type',
    sender: 'Sender',
    receiver: 'Receiver',
    user: 'User',
    assistant: 'Assistant',
    system: 'System',
    // Message page specific
    messageSender: 'Message Sender',
    messageContent: 'Message Content',
    voice: 'Voice',
    conversationTime: 'Conversation Time',
    conversationDate: 'Conversation Date',
    queryTable: 'Query Table',
    noAudio: 'No Audio',
    confirmDeleteMessage: 'Are you sure to delete this message?',
    today: 'Today',
    thisMonth: 'This Month',
    prompt: {
      exportSuccess: 'Export successful',
      exportFailed: 'Export failed',
      deleteSuccess: 'Delete successful',
      deleteFailed: 'Delete failed',
      saveSuccess: 'Save successful',
      saveFailed: 'Save failed',
      updateSuccess: 'Update successful',
      updateFailed: 'Update failed',
      addSuccess: 'Add successful',
      addFailed: 'Add failed',
      loading: 'Loading...',
      exporting: 'Exporting data...',
      deleting: 'Deleting...',
      saving: 'Saving...',
      updating: 'Updating...',
      adding: 'Adding...',
      serverMaintenance: 'Server maintenance/restarting, please try again later',
    },
  },

    agent: {
      agentName: 'Agent Name',
      agentDesc: 'Agent Description',
      publishTime: 'Publish Time',
      botId: 'Bot ID',
      coze: 'Coze',
      dify: 'Dify',
      appId: 'App ID',
      spaceId: 'Space ID',
      publicKey: 'Public Key',
      privateKey: 'Private Key',
      apiUrl: 'API URL',
      apiKey: 'API Key',
      enterAppId: 'Please enter Coze App ID',
      enterSpaceId: 'Please enter Coze Space ID',
      enterPublicKey: 'Please enter public key',
      enterPrivateKey: 'Please enter private key',
      enterApiUrl: 'Please enter API URL',
      enterApiKey: 'Please enter API Key',
      enterAgentName: 'Please enter agent name',
    },

    account: {
      profile: 'Profile',
      phone: 'Phone',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      enterName: 'Please enter name',
      enterPhone: 'Please enter phone number',
      enterEmail: 'Please enter email address',
      passwordPlaceholder: 'Leave blank to keep current password',
      confirmPasswordPlaceholder: 'Please enter password again',
      passwordStrength: 'Strength',
      passwordLevel: {
        low: 'Low',
        medium: 'Medium',
        strong: 'Strong',
      },
      passwordTip: 'Please enter at least 6 characters. Do not use easily guessed passwords.',
      updateSuccess: 'Personal information updated successfully',
      updateFailed: 'Update failed',
      validation: {
        passwordStrength: 'Password strength is insufficient',
        passwordMismatch: 'Passwords do not match',
      },
    },

  validation: {
    required: 'This field is required',
    email: 'Please enter a valid email address',
    phone: 'Please enter a valid phone number',
    password: 'Password must be 8-64 characters and not be all whitespace',
    confirmPassword: 'Passwords do not match',
    username: 'Username must be 3-32 characters, letters, numbers, and underscores only',
    minLength: 'Minimum {min} characters',
    maxLength: 'Maximum {max} characters',
    // Common validation messages
    enterEmail: 'Please enter email',
    enterValidEmail: 'Please enter a valid email format',
    enterLoginIdentifier: 'Please enter username, phone number, or email',
    enterUsername: 'Please enter username',
    usernameLength: 'Username length should be {min}-{max} characters',
    enterPassword: 'Please enter password',
    passwordLength: 'Password length should be {min}-{max} characters',
    enterConfirmPassword: 'Please confirm password',
    enterVerificationCode: 'Please enter verification code',
    verificationCodeLength: 'Verification code should be {length} digits',
    enterValidPhone: 'Please enter a valid phone number',
    enterName: 'Please enter name',
    nameLength: 'Name length should be {min}-{max} characters',
    enterWebSocketUrl: 'Please enter WebSocket address',
    enterValidWebSocketUrl: 'Please enter a valid address (starting with ws:// or wss://)',
    enterDeviceId: 'Please enter device ID',
  },

  dashboard: {
    dailySentence: 'Daily Sentence',
    clickToTranslate: 'Click to translate',
    getSentenceFailed: 'Failed to get daily sentence, using default value',
    conversationCount: 'Conversation Count',
    activeDevices: 'Active Devices',
    totalDevices: 'Total Devices',
    todayStats: 'Today\'s Statistics',
    userStats: 'User Statistics',
    deviceStats: 'Device Statistics',
    messageStats: 'Message Statistics',
    systemStatus: 'System Status',
    online: 'Online',
    offline: 'Offline',
    normal: 'Normal',
    abnormal: 'Abnormal',
    loading: 'Loading',
    noData: 'No Data',
    getFailed: 'Failed to get',


    greeting: {
      morning: 'Good Morning',
      forenoon: 'Good Morning',
      noon: 'Good Noon',
      afternoon: 'Good Afternoon',
      evening: 'Good Evening',
      night: 'Good Night',
    },
    welcome: {
      rest: 'Take a break',
      eat: 'What to eat?',
      game: 'Want to play a game?',
      tired: 'I guess you might be tired',
    },
  },

  error: {
    networkError: 'Network error, please check your connection',
    serverError: 'Server error',
    unauthorized: 'Unauthorized, please login again',
    forbidden: 'Access forbidden',
    notFound: 'Resource not found',
    timeout: 'Request timeout',
    unknown: 'Unknown error',
  },

  table: {
    index: 'Index',
    action: 'Action',
    total: 'Total {total} items',
    noData: 'No data',
  },

  page: {
    title: {
      dashboard: 'Dashboard',
      user: 'User Management',
      device: 'Device Management',
      deviceMaintenance: 'Device Maintenance',
      deviceCapabilityMaintenance: 'Device Capability Maintenance',
      deviceModelMaintenance: 'Device Model Maintenance',
      message: 'Message Management',
      role: 'Role Configuration',
      template: 'Template Management',
      agent: 'Agent Management',
      sttConfig: 'STT Configuration',
      ttsConfig: 'TTS Configuration',
      login: 'Login',
      register: 'Register',
      forget: 'Forgot Password',
      error403: '403 - Forbidden',
      error404: '404 - Not Found',
    },
  },

  router: {
    title: {
      login: 'Login',
      register: 'Register',
      forget: 'Forgot Password',
      dashboard: 'Dashboard',
      user: 'User Management',
      device: 'Device Management',
      deviceMaintenance: 'Device Maintenance',
      deviceCapabilityMaintenance: 'Device Capability Maintenance',
      deviceModelMaintenance: 'Device Model Maintenance',
      message: 'Message Management',
      role: 'Role Configuration',
      template: 'Prompt Template Management',
      llmConfig: 'LLM Configuration',
      agent: 'Agent Management',
      sttConfig: 'STT Configuration',
      ttsConfig: 'TTS Configuration',
      personalCenter: 'Account',
      account: 'Account',
      personalConfig: 'Settings',
      stellarAgentPrompt: 'Stellar Agent Instructions',
      error403: '403 - Forbidden',
      error404: '404 - Not Found',
      robotList: 'Robot List',
      // New Titles
      monitorDashboard: 'Dashboard',
      monitorLogs: 'Log Analysis',
      securityDashboard: 'Security Status',
      sensitiveWords: 'Sensitive Words',
      deviceMarket: 'Device Market',
      magicToolMarket: 'Magic Tool Market',
      creativeWorkshop: 'Creative Workshop',
      knowledgeBases: 'Knowledge Bases',
      knowledgeBaseDetail: 'Knowledge Base Detail',
      firmwareManagement: 'Firmware Management',
      agentTemplateList: 'Agent Templates',
      agentTemplateCreate: 'Create Agent Template',
      agentTemplateEdit: 'Edit Agent Template',
      multimodalAgentList: 'Role Management',
      multimodalAgentCreate: 'Create Role',
      multimodalAgentEdit: 'Edit Role',
      multimodalAgent: 'Role Management',
      multimodalAgentDetail: 'Role Detail',
      processingStrategy: 'Processing Strategy',
      perceptionData: 'Perception Data',
      orchestrator: 'Orchestration',
      testChat: 'Chat Test',
      robotDetail: 'Robot Detail',
      voiceprintManagement: 'Voiceprint Management',
      credentialCenter: 'Credential Center',
      // Paofu Product Management
      chatrooms: 'Chatrooms',
      chatroomDetail: 'Chatroom Detail',
      paofuGameScripts: 'Game Scripts',
      paofuGameScriptDetail: 'Script Detail',
      paofuExpression: 'Expression Resources',
      paofuAvatars: 'Virtual Avatars',
      paofuConfig: 'Paofu Config',
      paofuEmotion: 'Emotion Management',
      paofuAnalyticsDashboard: 'Analytics Dashboard',
      paofuAnalyticsEvents: 'Event Analytics',
      paofuAnalyticsBehavior: 'Behavior Analytics',
      paofuActivities: 'Activity Management',
      paofuActivityRankings: 'Activity Rankings',
      paofuContent: 'Story Management',
      paofuGrowth: 'Growth Tasks',
      paofuMallAssets: 'Mall Assets',
      paofuOrders: 'Order Management',
      paofuProducts: 'Product Management',
      paofuSocialFriends: 'Social Management',
      paofuSocialInvites: 'Invite Management',
      paofuSocialShares: 'Share Management',
      paofuFeedback: 'Feedback Management',
      paofuUserProfiles: 'User Profiles',
      memberPlanManage: 'Member Plans',
      memberSubscriptionList: 'Member Subscriptions',
      intentTest: 'Intent Recognition Test',
      // Permission Management
      permissionManagement: 'Permission Management',
      // Robot Agent Config
      robotAgentConfig: 'Robot Agent Config',
      // Logic Graph Visualization
      logicGraphView: 'Graph Visualization',
      // Unified Agent Management
      unifiedAgentManagement: 'Unified Agent Management',
      // Agent Configuration
      agentConfig: 'Agent Configuration',
      // Magic Tools
      magicTools: 'Magic Tools',
      // Voice Profile Management
      voiceProfileList: 'Voice Profiles',
      voiceProfileCreate: 'Create Voice Profile',
      voiceProfileEdit: 'Edit Voice Profile',
      // Tool Configuration
      toolLibrary: 'Tool Library',
      httpToolConfig: 'Create HTTP Tool',
      httpToolConfigEdit: 'Edit HTTP Tool',
      sqlToolConfig: 'Create SQL Tool',
      sqlToolConfigEdit: 'Edit SQL Tool',
      groovyToolConfig: 'Create Groovy Script',
      groovyToolConfigEdit: 'Edit Groovy Script',
      mqttToolConfig: 'Create MQTT Tool',
      mqttToolConfigEdit: 'Edit MQTT Tool',
      mcpToolConfig: 'Create MCP Tool',
      mcpToolConfigEdit: 'Edit MCP Tool',
      unifiedToolConfig: 'Create Tool',
      unifiedToolConfigEdit: 'Edit Tool',
      toolDebugger: 'Tool Debugger',
      mcpToolManagement: 'MCP Tool Management',
      workflowManagement: 'Workflow Management',
      knowledgeExtraction: 'Knowledge Extraction',
      knowledgeBase: 'Knowledge Base',
      knowledgePoints: 'Knowledge Points',
      logicGraph: 'Knowledge Graph',
      logicGraphDesign: 'Graph Design',
      documentLibrary: 'Document Library',
      fileLibrary: 'File Library',
      deviceDetail: 'Device Detail',
      magicAbilityMarket: 'Magic Tool Market',
      solutionMarket: 'Solution Market',
      dataMarket: 'Data Market',
      deviceMarketInternal: 'Device Market',
      robotConsole: 'Robot Console',
      // Tenant Management
      tenantManagement: 'Tenant Management',
      menuManagement: 'Menu Management',
      roleManagement: 'Role Management',
      // Plugin Marketplace
      pluginMarketplace: 'Plugin Marketplace',
      pluginDetail: 'Plugin Detail',
      pluginInstalled: 'Installed Plugins',
      pluginConnections: 'External Platforms',
      // Audit Logs
      auditLogs: 'Audit Logs',
      // Finance Center
      financeDashboard: 'Finance Dashboard',
      accountCenterAdmin: 'Account Center Admin',
      accountCenterOverview: 'Overview',
      accountCenterUsers: 'User Management',
      accountCenterWallet: 'Wallet Ledger',
      accountCenterDistribution: 'Distribution',
      accountCenterVerification: 'Verification',
      // Channel Management
      channelManage: 'Channel Management',
      channelAnalytics: 'Channel Analytics',
      // Task Management
      taskManage: 'Task Management',
      // Growth Management
      growthManage: 'Growth Management',
      // Content Management
      contentManage: 'Content Management',
      // Content Center (distinct from Paofu Content)
      contentCenterManage: 'Content Center',
      contentArticle: 'Article Management',
      // User Management
      userManage: 'User Management',
      // Member Management
      memberManage: 'Member Management',
      // Segment Management
      segmentManage: 'User Segment',
      // Data Analytics
      dataAnalytics: 'Data Analytics Dashboard',
      dataExport: 'Data Export',
      dataImport: 'Data Import',
      dataChangeLog: 'Change Log',
      apiAudit: 'API Audit',
      // Mall Center
      mallProducts: 'Product Management',
      mallOrders: 'Order Management',
      mallCoupons: 'Coupon Management',
      mallPayments: 'Payment Management',
      // Service Center
      serviceDashboard: 'Service Overview',
      ticketManage: 'Ticket Management',
      faqManage: 'FAQ Management',
      supportManualManage: 'User Manual',
    },
    parent: {
      roleManagement: 'Role Management',
      configManagement: 'Configuration',
      settings: 'Settings',
      orchestration: 'Orchestration',
      toolManagement: 'Tool Management',
      knowledgeManagement: 'Knowledge Management',
      deviceManagement: 'Smart Suite',
      monitorOps: 'Monitor & Ops',
      systemSecurity: 'System Security',
      dataManagement: 'Data Management',
      // New Parents
      robotManagement: 'Intelligent Services',
      deviceMarket: 'Device Market',
      magicToolMarket: 'Magic Tool Market',
      creativeWorkshop: 'Creative Workshop',
      systemSettings: 'System Settings',
      modelManagement: 'Model Management',
      workflowManagement: 'Workflow Management',
      // Paofu Product Management
      paofuManagement: 'Paofu Products',
      // Plugin Marketplace
      pluginMarket: 'Plugin Marketplace',
      // Mall Center
      mallCenter: 'Mall Center',
      // Finance Center
      financeCenter: 'Finance Center',
      // Account Center
      accountCenter: 'Account Center',
      // Marketing Center
      marketingCenter: 'Marketing Center',
      // Task/Growth/Content Centers merged into Paofu as direct children
      // Member Center
      memberCenter: 'Member Center',
      // Data Center
      dataCenter: 'Data Center',
      // Service Center
      serviceCenter: 'Service Center',
    },

  },

  // Tenant Management
  tenant: {
    title: 'Tenant Management',
    tenantCode: 'Tenant Code',
    tenantName: 'Tenant Name',
    enabled: 'Enabled',
    disabled: 'Disabled',
    addTenant: 'Add Tenant',
    editTenant: 'Edit Tenant',
    tenantCodeRequired: 'Please enter tenant code',
    tenantNameRequired: 'Please enter tenant name',
    tenantCodeLength: 'Tenant code must be 2-50 characters',
    tenantNameLength: 'Tenant name must be 2-100 characters',
    tenantCodePlaceholder: 'Enter tenant code',
    tenantNamePlaceholder: 'Enter tenant name',
    createSuccess: 'Tenant created successfully',
    createFailed: 'Failed to create tenant',
    updateSuccess: 'Tenant updated successfully',
    updateFailed: 'Failed to update tenant',
    deleteSuccess: 'Tenant deleted successfully',
    deleteFailed: 'Failed to delete tenant',
    confirmDelete: 'Are you sure to delete this tenant?',
    confirmDeleteContent: 'Deleting tenant "{name}" cannot be undone. Continue?',
    confirmToggleState: 'Are you sure to {action} tenant "{name}"?',
  },

  // Voice Profile Management
  voice: {
    title: 'Voice Profiles',
    create: 'Create Voice',
    cloneAction: 'Clone Voice',
    editVoice: 'Edit Voice',
    preview: 'Preview',
    provider: 'Provider',
    voiceId: 'Voice ID',
    voiceType: 'Type',
    preset: 'Preset',
    cloned: 'Cloned',
    gender: 'Gender',
    tags: 'Tags',
    cloneStatus: 'Clone Status',
    uploadSample: 'Upload Audio Sample',
    toolEnabled: 'Enable LLM Voice Switching',
    toolHint: 'When enabled, AI can autonomously select voice based on conversation',
    availableVoices: 'Available Voices',
    selectVoices: 'Select Voices',
    setDefault: 'Set as Default',
    minVoicesHint: 'Select at least 2 voices to enable voice switching',
    male: 'Male',
    female: 'Female',
    neutral: 'Neutral',
    language: 'Language',
    status: 'Status',
    system: 'System Preset',
    apiKey: 'API Key',
    apiUrl: 'API URL',
    // Clone status related
    clone: {
      pending: 'Pending',
      processing: 'Cloning',
      ready: 'Ready',
      failed: 'Clone Failed',
      submitted: 'Clone task submitted, processing...',
      success: 'Voice cloning completed',
      error: 'Voice cloning failed',
      notReady: 'Clone not complete, preview unavailable',
      providerHint: {
        volcengine: 'Requires accessToken/appId, cloning takes about 1-5 minutes',
        aliyun: 'Requires DashScope API Key, cloning takes about 1-3 minutes',
        elevenlabs: 'Requires API Key (elevenlabs.io), instant completion',
        fishSpeech: 'Requires API Key (fish.audio), instant completion',
        cosyvoice: 'Requires local CosyVoice API, zero-shot cloning completes instantly'
      }
    }
  },

  // Paofu Game Module
  paofuGame: {
    // Game Types
    gameType: {
      roleplay: 'Roleplay Script',
      galgame: 'Visual Novel',
      werewolf: 'Werewolf',
      puzzle: 'Puzzle Game',
    },
    // Script Status
    scriptStatus: {
      draft: 'Draft',
      published: 'Published',
      offline: 'Offline',
    },
    // Audit Status
    auditStatus: {
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
    },
    // Progress Status
    progressStatus: {
      inProgress: 'In Progress',
      completed: 'Completed',
      abandoned: 'Abandoned',
    },
    // Room Status
    roomStatus: {
      waiting: 'Waiting',
      playing: 'Playing',
      finished: 'Finished',
      closed: 'Closed',
    },
    // Admin Interface
    admin: {
      scriptList: 'Script List',
      createScript: 'Create Script',
      editScript: 'Edit Script',
      scriptTitle: 'Script Title',
      scriptDescription: 'Script Description',
      coverImage: 'Cover Image',
      difficulty: 'Difficulty',
      estimatedTime: 'Estimated Time',
      tags: 'Tags',
      publish: 'Publish',
      offline: 'Offline',
      audit: 'Audit',
      approve: 'Approve',
      reject: 'Reject',
      auditReason: 'Audit Reason',
      parseDocument: 'Parse Document',
      uploadDocument: 'Upload Document',
      parseResult: 'Parse Result',
      extractCharacters: 'Extract Characters',
      generateDetails: 'Generate Details',
      modifyByText: 'Modify by Text',
      modifyByVoice: 'Modify by Voice',
      characterList: 'Character List',
      characterName: 'Character Name',
      characterDescription: 'Character Description',
      characterPersonality: 'Personality',
      characterBackground: 'Background Story',
      isAiNpc: 'AI NPC',
      aiSystemPrompt: 'AI System Prompt',
      roleType: 'Role Type',
      protagonist: 'Protagonist',
      supporting: 'Supporting',
      npc: 'NPC',
      antagonist: 'Antagonist',
      sceneList: 'Scene List',
      dialogueNodes: 'Dialogue Nodes',
      endings: 'Endings',
      confirmPublish: 'Are you sure to publish this script?',
      confirmOffline: 'Are you sure to offline this script?',
      confirmDelete: 'Are you sure to delete this script?',
      publishSuccess: 'Published successfully',
      offlineSuccess: 'Offline successfully',
      auditSuccess: 'Audit completed',
      parseSuccess: 'Parsed successfully',
      extractSuccess: 'Extracted successfully',
      modifySuccess: 'Modified successfully',
    },
    // Document Parse Steps
    parseSteps: {
      step1: 'Upload Document',
      step2: 'Parse Preview',
      step3: 'Edit Characters',
      step4: 'Confirm Creation',
      selectGameType: 'Select Game Type',
      uploadTip: 'Supports TXT, DOC, DOCX, PDF formats',
      parsing: 'Parsing document...',
      extracting: 'Extracting characters...',
      generating: 'Generating details...',
      modifying: 'Modifying character...',
      recording: 'Recording...',
      startRecording: 'Start Recording',
      stopRecording: 'Stop Recording',
      voiceInputTip: 'Click record button and describe your modifications by voice',
      textInputTip: 'Enter your modifications',
      confirmCreate: 'Confirm Create Script',
    },
    // Game Lobby
    lobby: {
      availableRooms: 'Available Rooms',
      createRoom: 'Create Room',
      joinRoom: 'Join Room',
      roomName: 'Room Name',
      maxPlayers: 'Max Players',
      currentPlayers: 'Current Players',
      host: 'Host',
      ready: 'Ready',
      unready: 'Unready',
      start: 'Start Game',
      leave: 'Leave Room',
      selectCharacter: 'Select Character',
    },
    // Game Progress
    progress: {
      myProgress: 'My Progress',
      completionRate: 'Completion',
      playTime: 'Play Time',
      currentNode: 'Current Node',
      continueGame: 'Continue',
      abandonGame: 'Abandon',
      confirmAbandon: 'Are you sure to abandon this game? Progress cannot be recovered.',
    },
  },

  system: {
    tip: {
      wsConnectionFailed: 'WebSocket connection failed, some features may be unavailable',
      notConnected: 'Not connected to server, please check chat configuration',
      connectionFailed: 'Connection failed: {error}',
      sendFailed: 'Send failed, please check connection status',
      recordingFailed: 'Failed to start recording, please check microphone permissions',
      stopRecordingFailed: 'Failed to stop recording',
    }
  },

  // Multimodal Agent
  multimodal: {
    agent: 'Multimodal Agent',
    strategy: 'Processing Strategy',
    perception: 'Perception Data',
    modalityType: 'Modality Type',
    processingMode: 'Processing Mode',
    priority: 'Priority',
    status: 'Status',
    start: 'Start',
    stop: 'Stop',
    reset: 'Reset',
    running: 'Running',
    stopped: 'Stopped',
    error: 'Error',
    agentName: 'Agent Name',
    agentType: 'Agent Type',
    robotId: 'Associated Robot',
    strategyName: 'Strategy Name',
    enabled: 'Enabled',
    disabled: 'Disabled',
    processorConfig: 'Processor Configuration',
    confirmDelete: 'Are you sure you want to delete?',
    confirmStart: 'Are you sure you want to start this agent?',
    confirmStop: 'Are you sure you want to stop this agent?',
    // Prompt Template Related
    promptTemplate: 'Prompt Template',
    selectPromptTemplate: 'Please select a Prompt Template',
    loadTemplatesFailed: 'Failed to load template list',
    templatePreview: 'Template Preview',
    templateName: 'Template Name',
    templateType: 'Template Type',
    version: 'Version',
    description: 'Description',
    systemPrompt: 'System Prompt',
    userPromptTemplate: 'User Prompt Template',
    variables: 'Variables',
    fewShotExamples: 'Few-shot Examples',
    examples: 'examples',
    // Type Matching Related
    incompatible: 'Incompatible',
    filteringByAgentType: 'Filtering by Agent Type: {type}',
    compatibleOnly: 'Compatible Only',
    showAll: 'Show All',
    compatibleTemplateTypes: 'Compatible Template Types',
    currentTemplateIncompatible: 'Current selected template is incompatible with agent type, automatically cleared',
    promptTemplateTip: 'Select a Prompt template suitable for this agent type',
    // Other Fields
    agentNameRequired: 'Please enter agent name',
    agentNameLength: 'Agent name length should be 2-50 characters',
    agentTypeRequired: 'Please select agent type',
    inputModalitiesRequired: 'Please select at least one input modality',
    outputModalitiesRequired: 'Please select at least one output modality',
    loadLlmConfigsFailed: 'Failed to load LLM configuration list',
    selectRobot: 'Please select a robot',
    robotTip: 'Optional: Associate with a specific robot',
  },

  // Credential Configuration Center
  credential: {
    center: {
      title: 'Credential Center',
      createCredential: 'Create Credential',
      editCredential: 'Edit Credential',
      rotateCredential: 'Rotate Credential',
      allServices: 'All Services',
      llm: 'LLM',
      tts: 'TTS',
      asr: 'ASR',
      vision: 'Vision',
      embedding: 'Embedding',
      entityType: 'Entity Type',
      entityId: 'Entity ID',
      entity: 'Entity',
      serviceType: 'Service Type',
      provider: 'Provider',
      credentialName: 'Credential Name',
      status: 'Status',
      enabled: 'Enabled',
      disabled: 'Disabled',
      deleted: 'Deleted',
      createTime: 'Create Time',
      searchPlaceholder: 'Search credential name',
      selectEntityType: 'Select entity type',
      selectEntity: 'Select entity',
      selectServiceType: 'Select service type',
      selectProvider: 'Select provider',
      credentialNamePlaceholder: 'Identifiable name, e.g., OpenAI-Production',
      entityTypeRequired: 'Please select entity type',
      entityIdRequired: 'Please select entity',
      serviceTypeRequired: 'Please select service type',
      providerRequired: 'Please select provider',
      loadFailed: 'Failed to load credential list',
      loadEntitiesFailed: 'Failed to load entity list',
      createSuccess: 'Credential created successfully',
      createFailed: 'Failed to create credential',
      updateSuccess: 'Credential updated successfully',
      updateFailed: 'Failed to update credential',
      deleteSuccess: 'Credential deleted successfully',
      deleteFailed: 'Failed to delete credential',
      confirmDelete: 'Are you sure you want to delete this credential?',
      enableSuccess: 'Credential enabled',
      disableSuccess: 'Credential disabled',
      toggleStateFailed: 'Failed to toggle state',
      totalItems: 'Total {total} items',
      required: ' is required',
      rotate: 'Rotate',
      testConnection: 'Test Connection',
      rotateSuccess: 'Credential rotated successfully',
      rotateFailed: 'Failed to rotate credential',
      testing: 'Testing connection...',
      testSuccess: 'Connection test successful',
      testFailed: 'Connection test failed',
    },
  },

  // Personal Settings
  settings: {
    title: 'Settings',
    preferences: 'Preferences',
    notifications: 'Notifications',
    security: 'Security',
    accountManagement: 'Account',
    tenantManagement: 'Tenant Management',
    theme: 'Theme',
    themeLight: 'Light',
    themeDark: 'Dark',
    themeSystem: 'System',
    language: 'Language',
    navigationMode: 'Navigation Mode',
    navTabs: 'Tabs',
    navSidebar: 'Sidebar',
    defaultHome: 'Default Home',
    soundEnabled: 'Sound Notification',
    systemNotification: 'System Notification',
    systemNotificationDesc: 'Receive system announcements and maintenance notices',
    deviceAlert: 'Device Alert',
    deviceAlertDesc: 'Device offline and abnormal status alerts',
    chatMessage: 'Chat Message',
    chatMessageDesc: 'New conversation and robot message notifications',
    emailNotification: 'Email Notification',
    emailNotificationDesc: 'Important events pushed via email',
    quietHours: 'Do Not Disturb',
    quietHoursDesc: 'No notifications during this period',
    securityScore: 'Security Score',
    securityScoreDesc: 'Based on account security configuration',
    oauthBindings: 'Third-party Account Binding',
    wechat: 'WeChat',
    bound: 'Bound',
    notBound: 'Not Bound',
    bindNow: 'Bind Now',
    unbind: 'Unbind',
    unbindConfirm: 'Are you sure you want to unbind this third-party account?',
    unbindSuccess: 'Unbind successful',
    unbindFailed: 'Unbind failed',
    accountInfo: 'Account Info',
    registerTime: 'Register Time',
    dangerZone: 'Danger Zone',
    deleteAccount: 'Delete Account',
    deleteAccountDesc: 'Account data will be permanently deleted after deletion, this operation is irreversible',
    deleteAccountConfirm: 'Are you sure you want to delete your account? This operation is irreversible!',
    deleteAccountSuccess: 'Account deleted',
    deleteAccountFailed: 'Failed to delete account',
    featureInDevelopment: 'Feature in development',
    saveSuccess: 'Settings saved successfully',
    saveFailed: 'Failed to save settings',
  },

  component: {
    settings: {
      title: 'System Settings',
      theme: {
        title: 'Theme Mode',
        light: 'Light',
        dark: 'Dark',
        auto: 'Auto',
        current: 'Current',
        actual: 'Actual',
      },
      language: {
        title: 'Language Settings',
        current: 'Current Language',
      },
      quickActions: {
        title: 'Quick Actions',
        clearCache: 'Clear Cache',
        resetSettings: 'Reset Settings',
        exportSettings: 'Export Settings',
        importSettings: 'Import Settings',
      },
    },
    globalLoading: {
      loading: 'Loading...',
    },
    errorBoundary: {
      title: 'Page Error',
      description: 'Sorry, the page encountered some issues.',
      retry: 'Retry',
      goHome: 'Go Home',
    },
    pageSkeleton: {
      loading: 'Page Loading...',
    },
    audioPlayer: {
      play: 'Play',
      pause: 'Pause',
      stop: 'Stop',
      volume: 'Volume',
      speed: 'Playback Speed',
      currentTime: 'Current Time',
      duration: 'Duration',
    },
    floatingChat: {
      title: 'AI Assistant',
      placeholder: 'Please enter your question...',
      send: 'Send',
      clear: 'Clear',
      minimize: 'Minimize',
      maximize: 'Maximize',
    },
    deviceEditDialog: {
      title: 'Edit Device',
      addTitle: 'Add Device',
      deviceName: 'Device Name',
      deviceType: 'Device Type',
      owner: 'Device Owner',
      online: 'Online',
      offline: 'Offline',
    },

  },
}
